import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import PaintTitle from './PaintTitle';
import TerminalContact from './TerminalContact';

export default function Contact({ isQuant = false }) {
    const [status, setStatus] = useState('');
    const [sending, setSending] = useState(false);
    async function submit(event) {
        event.preventDefault();
        if (sending) return;
        const form = event.currentTarget;
        const values = Object.fromEntries(new FormData(form));
        setSending(true);
        setStatus('Sending your message...');
        try {
            await emailjs.send('service_63p8z4a', 'template_a67qcun', values, 'Wa_IlKxPZelX5d7sW');
            setStatus('Message sent. Thanks for getting in touch.');
            form.reset();
        } catch {
            setStatus('The message could not be sent. Please try again or reach me on LinkedIn.');
        } finally { setSending(false); }
    }
    return <section className="contact-section" id="contact">
        <PaintTitle>Get in touch.</PaintTitle>
        <p>{isQuant ? "For quantitative research or development opportunities, or a conversation about the arbitrage engine and its research methods." : "For opportunities in quantum engineering, robotics, embedded systems, or quantitative research, or a conversation about something you are building."}</p>
        <div className="work-links"><a href="#contact-form">Send email</a><a href="https://github.com/KPerlman" target="_blank" rel="noreferrer">GitHub</a><a href="https://www.linkedin.com/in/kyleperlman/" target="_blank" rel="noreferrer">LinkedIn</a></div>
        <form id="contact-form" className="contact-form" onSubmit={submit}>
            <label>Your email<input name="email" type="email" autoComplete="email" required disabled={sending} /></label>
            <label>Subject<input name="subject" required maxLength={200} disabled={sending} /></label>
            <label className="contact-message">Message<textarea name="message" rows={5} required maxLength={10000} disabled={sending} /></label>
            <button type="submit" disabled={sending}>{sending ? 'Sending...' : 'Send message'}</button>
            <p role="status">{status}</p>
        </form>
        <details className="contact-terminal-option"><summary>Prefer a terminal?</summary><TerminalContact /></details>
    </section>;
}
